<template>
  <div class="chart-savings">
    <CommonColumnData
      class="chart-savings-title"
      style="margin-bottom: var(--spacer)"
      :label="name"
      :data="`${sum()} ${unit}`"
    />
    <CommonLoader v-if="data().length === 0" style="padding-top: 20px" />
    <div class="chart-container" v-else>
      <apexchart
        v-if="dataset"
        class="chart-savings-chart"
        :series="data()"
        :options="{
          chart: {
            type: 'donut'
          },
          legend: {
            show: false
          },
          dataLabels: {
            enabled: false
          },
          tooltip: {
            y: {
              formatter: (v: number) => {
                return `${v.toFixed(0)} ${unit}`
              }
            }
          },
          colors: colors(),
          labels: labels(),
          plotOptions: {
            bar: {
              borderRadius: 0,
              borderWidth: 0
            },
            pie: {
              donut: {
                size: '50%'
              }
            }
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 400
                },
                legend: {
                  position: 'bottom'
                }
              }
            }
          ]
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import CommonColumnData from '@/components/common/CommonColumnData.vue'
import CommonLoader from '@/components/common/CommonLoader.vue'
import { get_device_name } from '@/service/service_device'

const props = defineProps<{
  name: string
  dataset: Record<string, never> | undefined
  unit: string
}>()

function labels() {
  let output = []
  for (const id in props.dataset) {
    output.push(get_device_name(id))
  }
  return output
}

function data() {
  let output: number[] = []
  for (const id in props.dataset) {
    output.push(props.dataset[id])
  }
  return output
}

function sum() {
  let output = 0
  for (const id in props.dataset) {
    const value = props.dataset[id]
    output += value ?? 0
  }

  return Number(output.toFixed(0)).toLocaleString('fr-FR')
}

function colors() {
  return labels().map((name) => deviceColors[name] || '#ccc')
}

const deviceColors: Record<string, string> = {
  Kipopluie: '#0055A3',
  Aquasmart: '#0072CE',
  Soprasolar: '#4D9FE8'
}
</script>

<style scoped>
.chart-container {
  display: flex;
  justify-content: center;
}
.chart-savings {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  background-color: var(--vc-white);
  padding: var(--spacer);
  border-radius: var(--br-medium);
}
</style>

<style>
.chart-savings-title > p {
  padding: 0 5px;
}
</style>
